'use client';

import { useClientConfig } from '@providers/ClientConfigProvider';
import { useEffect } from 'react';

export default function AppLinkInterceptor() {
  const { APP_URL } = useClientConfig();

  useEffect(() => {
    if (!APP_URL) return;

    let appOrigin: string;
    try {
      appOrigin = new URL(APP_URL).origin;
    } catch {
      return;
    }

    if (appOrigin === window.location.origin) return;

    const handler = (event: MouseEvent) => {
      const anchor = (event.target as HTMLElement | null)?.closest?.('a');
      if (!anchor) return;
      const href = anchor.getAttribute('href');
      if (!href) return;

      let target: URL;
      try {
        target = new URL(href, window.location.href);
      } catch {
        return;
      }
      if (target.origin !== appOrigin) return;
      if (target.searchParams.has('aid')) return;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const aid = (window as any).anonymousId as string | undefined;
      if (!aid) return;

      target.searchParams.set('aid', aid);
      anchor.setAttribute('href', target.toString());
    };

    // Capture phase so we run before any other click handler (including
    // framework router interception) reads `href`.
    document.addEventListener('click', handler, true);
    document.addEventListener('auxclick', handler, true);

    return () => {
      document.removeEventListener('click', handler, true);
      document.removeEventListener('auxclick', handler, true);
    };
  }, [APP_URL]);

  return null;
}
